import { DropShadow, Stroke, TextWrapping } from 'editor/src/store/design/types';

import type { FontMetaData, FontStyle, FontWeight } from '@gelatoas/design-editor-fonts';

export interface UploadedFontData {
  fontFile: string;
  name: string;
  family: string;
  weight: FontWeight;
  style: FontStyle;
  fileUrl?: string;
  previewUrl?: string;
  filename: string;
  isProtected?: boolean;
  hasWarning?: boolean;
  loadingStatus?: FontStatus;
}

export interface FontState {
  availableFonts: FontDefinition[];
  uploadedFonts: UploadedFontData[];
  // False until the host has told us what the customer's uploaded fonts are,
  // so the section can say it is loading rather than silently not existing.
  uploadedFontsReceived: boolean;
  fontUploadEnabled: boolean;
  fontUploadButtonHidden: boolean;
  fontUploadPlusRequired: boolean;
  defaultFontStyles: FontStyles;
}

export enum FontStatus {
  new,
  ready,
  loading,
  failed,
}

export interface FontDefinition {
  status: FontStatus;
  metadata: FontMetaData;
  isPopular: boolean;
  isEmbroidery: boolean;
  isUploaded?: boolean;
  popularOrder?: number;
  embroideryOrder?: number;
}

export interface FontStyles {
  underline: boolean;
  linethrough: boolean;
  fontFamily: string;
  fontSize: number;
  color: string;
  lineHeight: number;
  textAlign: TextAlign;
  direction: TextDirection;
  angle: number;
  letterSpacing: number;
  stroke: Stroke;
  shadow: DropShadow;
  wrapping: TextWrapping | undefined;
  curve: number;
}

export enum TextAlign {
  left = 'left',
  right = 'right',
  center = 'center',
}

export enum TextDirection {
  rtl = 'rtl',
  ltr = 'ltr',
}

export interface SharedFontMetadata {
  isShared: true;
  metadata: FontDefinition['metadata'];
}

export interface MixedFontMetadata {
  isShared: false;
  allMetadata: Record<number, FontDefinition['metadata']>;
}

export type FontMetadataState = SharedFontMetadata | MixedFontMetadata;
